import { buildModelManager } from "../builder.js";
const DefaultMicuMedicationLogSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  field: true,
  medicationId: true,
  newValue: true,
  oldValue: true,
  timestamp: true,
  updatedAt: true
};
const modelApiIdentifier = "micuMedicationLog";
const pluralModelApiIdentifier = "micuMedicationLogs";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultMicuMedicationLogSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultMicuMedicationLogSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultMicuMedicationLogSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultMicuMedicationLogSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultMicuMedicationLogSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultMicuMedicationLogSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultMicuMedicationLogSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "micuMedicationLogGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const MicuMedicationLogManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultMicuMedicationLogSelection,
  operations
);
export {
  DefaultMicuMedicationLogSelection,
  MicuMedicationLogManager
};
//# sourceMappingURL=MicuMedicationLog.js.map
